import { Layout } from '@consta/uikit/Layout'
import {
  selectProjectCount,
  selectProjectError,
  selectProjectStatus,
  useAppSelector,
} from '@core/core/store'
import { CenteredLoader } from '@library/components'

import { EmptyProjectsPlaceholder } from './EmptyProjectsPlaceholder'
import { ErrorLoadingProjectsPlaceholder } from './ErrorLoadingProjectsPlaceholder'
import css from './Main.css'
import { MainHeader } from './MainHeader'
import { ProjectsView } from './ProjectsView'

export const Main = () => {
  const isEmptyProjects = !useAppSelector(selectProjectCount)
  const status = useAppSelector(selectProjectStatus)
  const error = useAppSelector(selectProjectError)

  if (error) {
    return (
      <div className={css.errorLoading}>
        <ErrorLoadingProjectsPlaceholder />
      </div>
    )
  }

  if (status === 'done' && isEmptyProjects) {
    return (
      <Layout className={css.page}>
        <EmptyProjectsPlaceholder />
      </Layout>
    )
  }

  if (isEmptyProjects) {
    return <CenteredLoader />
  }

  return (
    <Layout className={css.page}>
      <Layout direction="column" className={css.container}>
        <MainHeader />
        <ProjectsView />
      </Layout>
    </Layout>
  )
}
